import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from "../shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AddonsRoutingModule } from './addons-routing.module';
import { AddonCardComponent } from './addon-card/addon-card.component';


@NgModule({
  declarations: [AddonCardComponent],
  imports: [
    CommonModule,
  //  AddonsRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports:[
    AddonCardComponent
  ]
})
export class AddonsModule { }
